import { CustomDataSource, ImageryLayer } from 'cesium';
import { getVectorFeatureInfoByText, getWmsFeatureInfoByText, poiSearch } from '../../_util/layer';
import FeatureLayer from '../../feature-layer/FeatureLayer';
import ImageLayer from '../../image-layer/ImageLayer';

export default mapRef => {
    const getMapLayers = searchText => {
        return new Promise(resolve => {
            const list = [];
            const promiseList = [];

            mapRef.current.getAllLayers().map(layer => {
                if (layer.show && layer.key && layer.labelField) {
                    let label = layer.name;
                    let field = layer.labelField;
                    if (layer instanceof FeatureLayer) {
                        let features = layer.getFeaturesBySearch(field, searchText || 'name');
                        if (features?.length) {
                            list.push({ label, options: features });
                        }
                    } else if (layer instanceof ImageLayer) {
                        promiseList.push(
                            layer
                                .getFeaturesBySearch(field, searchText || 'code')
                                .then(features => {
                                    return {
                                        label,
                                        options: features,
                                    };
                                }),
                        );
                    } else if (layer instanceof CustomDataSource) {
                        let features = getVectorFeatureInfoByText(
                            layer,
                            field,
                            searchText || 'name',
                        );
                        if (features?.length) {
                            list.push({ label, options: features });
                        }
                    } else if (layer instanceof ImageryLayer) {
                        promiseList.push(
                            getWmsFeatureInfoByText(layer, field, searchText || 'code').then(
                                features => {
                                    return {
                                        label,
                                        options: features,
                                    };
                                },
                            ),
                        );
                    } else if (layer.getFeaturesBySearch) {
                        let features = layer.getFeaturesBySearch(field, searchText || 'name');
                        if (features?.length) {
                            list.push({ label, options: features });
                        }
                    }
                }
            });

            if (promiseList?.length) {
                Promise.all(promiseList).then(res => {
                    if (res?.length) {
                        res.map(v => {
                            if (v.options?.length) {
                                list.push(v);
                            }
                        });
                    }

                    resolve(list);
                });
            } else {
                resolve(list);
            }
        });
    };

    const getAddressLayers = async searchText => {
        const data = await poiSearch({ keywords: searchText });

        if (data?.length) {
            return data.map(item => {
                return {
                    label: item.name,
                    value: item.name,
                    lngLat: item.lngLat,
                };
            });
        }
    };
    return ({ type, searchText }) => {
        return new Promise(resolve => {
            const TYPE = {
                address: getAddressLayers,
                layer: getMapLayers,
            };
            TYPE[type](searchText).then(data => {
                resolve(data);
            });
        });
    };
};
